import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["innerHTML"]

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import { Icons } from "src/util/enums/fontAwesomeIcons"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogIdentifierUnknown',
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {



//endregion

//region Variables

const { dialogRef, onDialogHide, onDialogOK } = useDialogPluginComponent()

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    onHide: _unref(onDialogHide)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3 row justify-between" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("sfxDialogIdentifier.title_unknown")), 1),
              _createVNode(_component_q_icon, {
                name: _unref(Icons).INFORMATION
              }, null, 8, ["name"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("p", {
                innerHTML: _ctx.$t('sfxDialogIdentifier.text1_unknown')
              }, null, 8, _hoisted_1),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('sfxDialogIdentifier.text2_unknown')
              }, null, 8, _hoisted_2)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(SfxBtn, {
                onClick: _unref(onDialogOK),
                label: _ctx.$t('sfxButtons.btn_understood'),
                class: "col-grow"
              }, null, 8, ["onClick", "label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}
}

})